import React from 'react'
import useFetch from 'hooks/useFetch'

import { Paper } from '@material-ui/core'

import EntriesTable from '../../../Entries/components/EntriesTable/EntriesTable'

import * as service from 'service'

const EntryInfo = ({ contractId, status }) => {
  const { response, isLoading, refresh } = useFetch(
    service.recurrence.entries.get,
    {
      contractId,
    },
  )

  const afterEvent = () => {
    refresh()
  }

  return (
    <Paper>
      <EntriesTable
        contractId={contractId}
        isLoading={isLoading}
        contractStatus={status}
        onEvent={afterEvent}
        data={response && response.data}
      />
    </Paper>
  )
}

export default EntryInfo
